<template>
  <section id="login">
    <div style="margin-top:100px; margin-bottom:150px; ">
      <!-- Login Form -->

      <div class="container h-100 d-flex justify-content-center;">
        <div class="login my-auto" style="margin:auto; width:400px">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>
          <transition name="slideAnim" type="animation" appear mode="out-in">
            <form
              v-if="!procesando && !ingresarOTP && !passwordOK"
              style="padding:10px; margin:30px"
            >
              <h3 style="text-align:center; padding-bottom:15px">Recuperá la contraseña</h3>

              <div class="form-group">
                <label>Usuario</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="correo"
                  aria-describedby="emailHelp"
                  placeholder="Ingresá tu usuario"
                />
              </div>

              <div class="form-group">
                <label>Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="pass"
                  placeholder="Ingresá tu contraseña"
                />
              </div>

              <div class="form-group">
                <label>Repetí Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="passC"
                  placeholder="Ingresá tu contraseña"
                />
              </div>

              <div v-if="mensaje" class="alert alert-danger" role="alert">{{mensaje}}</div>

              <div style="text-align:center">
                <button type="button" class="btn boton-primario" @click="recupero()">Continuar</button>
              </div>
            </form>
          </transition>

          <div v-if="procesando" style="text-align:center;">
            <h3 style="text-align:center; padding-bottom:15px">Enviando número secreto</h3>
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>

          <div v-if="ingresarOTP" style="text-align:center;">
            <h5
              style="text-align:center; padding-bottom:15px; padding-top:50px"
            >Para confirmar la contraseña ingresada, escribí el código que te enviamos a {{correo}}</h5>

            <form id="claveAleatoria" autocomplete="off" @submit.prevent="ingresoOTP">
              <input
                type="text"
                style="width:200px; margin:auto"
                class="form-control"
                v-model="clave"
                aria-describedby="claveRecibida"
                placeholder="Ingresá la clave recibida"
              />

              <div v-if="mensaje" class="alert alert-danger" role="alert">{{mensaje}}</div>
              <button
                type="button"
                class="btn boton-primario"
                style="margin-top:30px"
                @click="ingresoOTP()"
              >Aceptar</button>
            </form>
            <img
              src="public/images/site/recupero.svg"
              alt="recupero"
              style="padding: 20px; width:200px"
            />
            <p>¿No te llegó?</p>
            <h6 class="olvide-password" @click="recupero()">Enviar código nuevamente</h6>
          </div>

          <div v-if="passwordOK" style="text-align:center;">
            <h3
              style="text-align:center; padding-bottom:15px"
            >¡La contraseña se cambió exitosamente!</h3>
            <img src="public/images/site/subir-challenge.svg" class="img img-fluid" />
            <button
              type="button"
              class="btn boton-primario"
              style="margin-top:30px"
              @click="volver()"
            >Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "login",

  data() {
    return {
      pass: null,
      passC: null,
      correo: null,
      respuesta: "",
      mensaje: null,
      clave: null,
      procesando: false,
      ingresarOTP: false,
      passwordOK: false
    };
  },

  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },

  methods: {
    recupero() {
      var self = this;
      if (!self.correo) {
        self.mensaje = "Debés ingresar una dirección de correo electrónico";
        return;
      }
      if (!self.pass) {
        self.mensaje = "Debés ingresar una contraseña nueva";
        return;
      }
      if (!self.passC) {
        self.mensaje = "Debés ingresar la confirmación de la contraseña";
        return;
      }

      if (self.pass != self.passC) {
        self.mensaje = "Las contraseñas deben ser iguales";
        return;
      }

      self.procesando = true;
      self.ingresarOTP = false;

      var bodyApi;
      bodyApi = "email=" + self.correo + "&pass=" + self.pass;

      fetch(self.pathAPI + "ApiCambioClave.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          self.procesando = false;
          self.ingresarOTP = true;
          var loginResponse;

          loginResponse = response.json();

          loginResponse.then(function(result) {
            if (result.resultado === "ERROR") {
              self.procesando = false;
              self.ingresarOTP = false;
              self.mensaje = result.mensaje;
            } else {
              self.mensaje = null;
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    ingresoOTP() {
      var self = this;
      if (!self.clave) {
        self.mensaje =
          "Debés ingresar el código que te enviamos a" + self.correo;
        return;
      }
      var bodyApi;
      bodyApi = "clave=" + self.clave;

      fetch(self.pathAPI + "ApiClaveAleatoria.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          loginResponse = response.json();

          var loginResponse;
          loginResponse.then(function(result) {
            if (result.resultado === "ERROR") {
              self.mensaje = "El código ingresado es incorrecto";
            } else {
              self.passwordOK = true;
              self.ingresarOTP = false;
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    volver() {
      this.$router.push({ path: "/Login" });
    }
  },
  components: {},

  mounted: function() {}
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}

.login {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/ForgotPassword.vue